// Theme controller — SCOPED so public and admin never share a theme value.
//
//  • Public TeamBuilder surfaces are ALWAYS dark. They never read a saved
//    preference, localStorage, or the OS setting.
//  • Admin/authenticated surfaces use a user-selectable preference
//    ("dark" | "light" | "system") persisted under an admin-specific key.
//
// The resolved theme ("dark" | "light") is written to <html data-theme="...">.
// Route-based application is handled by <ThemeManager />.

const ADMIN_KEY = "teambuilder_admin_theme";
const LEGACY_KEY = "rd_theme"; // migrate any previously-global value
const VALID = ["dark", "light", "system"];

const mql = () =>
  typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(prefers-color-scheme: dark)")
    : null;

export const getAdminPreference = () => {
  try {
    let p = localStorage.getItem(ADMIN_KEY);
    if (!VALID.includes(p)) {
      // One-time migration from the old global key, if present.
      const legacy = localStorage.getItem(LEGACY_KEY);
      if (VALID.includes(legacy)) {
        localStorage.setItem(ADMIN_KEY, legacy);
        p = legacy;
      }
    }
    return VALID.includes(p) ? p : "dark";
  } catch (e) {
    return "dark";
  }
};

export const resolveTheme = (pref) => {
  if (pref === "system") {
    const m = mql();
    return m && m.matches ? "dark" : "light";
  }
  return pref === "light" ? "light" : "dark";
};

export const applyTheme = (resolved) => {
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute(
      "data-theme",
      resolved === "light" ? "light" : "dark"
    );
  }
};

// Public routes: hard-locked to dark.
export const forceDark = () => applyTheme("dark");

// Admin routes: apply the saved admin preference.
export const applyAdminTheme = () => applyTheme(resolveTheme(getAdminPreference()));

export const setAdminPreference = (pref) => {
  const next = VALID.includes(pref) ? pref : "dark";
  try {
    localStorage.setItem(ADMIN_KEY, next);
  } catch (e) {
    /* ignore */
  }
  applyAdminTheme();
  try {
    window.dispatchEvent(new CustomEvent("rd-theme-change", { detail: next }));
  } catch (e) {
    /* ignore */
  }
  return next;
};
